<template>
	<div class="org_cn">
		<div class="origin_pc" v-if="!isPhone">
			<div class="orpc_wrap">
				<div class="hd_img">
					<img src="@/images/lishi/bmg66.png">
				</div>
				<div class="orpc_con">
					<div class="orpc_item1" data-aos="zoom-in">
						<div class="orpc_item1_left">
							<img src="@/images/lishi/bmg9.png" />
						</div>
						<div class="orpc_item1_right">
							<img src="@/images/lishi/tit1.png" />
							<p>巴山钟灵，蜀水毓秀。</p>
							<p>
								在巴蜀大地著名的 U
								型酿酒带，绵竹的酿酒历史可追溯至四千余年前。从三星堆蜀文化遗址出土的陶酒具，绵竹金土村出土的战国时期铜罍、提梁壶，以及东汉时期的酿酒画像砖，还有《华阳国志・蜀志》《晋书》等史书记载，都证实绵竹产酒不晚于战国时期。这些早期的酿酒文明，为剑南春独特酿造工艺的形成与发展奠定了深厚根基，开启了剑南春传承千年的传奇篇章。
							</p>
						</div>
					</div>
					<div class="orpc_item2" data-aos="zoom-in">
						<div class="orpc_item2_left">
							<img src="@/images/lishi/tit2.png" />
							<p>
								唐朝时期，百业兴旺，绵竹成熟的酿酒技艺孕育出了“剑南烧春”，倾动朝野。
							</p>
							<p>
								唐人李肇在《唐・国史补》中记载：“酒则有……
								乌程之若下，剑南之烧春……”，《旧唐书·德宗本纪》明确记载：“剑南岁贡春酒十斛”，德宗亲自过问进贡事宜。“剑南烧春” 作为宫廷御酒，成为历史上唯一载入正史的宫廷御酒，也是中国至今尚存的唐代名酒。剑南春自此在历史舞台上崭露头角，声名远扬。
							</p>
						</div>
						<div class="orpc_item2_right">
							<img src="@/images/lishi/bmg10.png" />
						</div>
					</div>
					<div class="orpc_item3" data-aos="zoom-in">
						<div class="tm3_d1 flex1">
							<img class="tm3_d1_img1" src="@/images/lishi/tit3.png" />
							<img class="tm3_d1_img2" src="@/images/lishi/yun1.png" />
						</div>
						<p class="tm3_line">
							<span class="le_jx"></span>
							<span class="le_hx"></span>
							<span class="le_jx"></span>
						</p>
						<div class="tm3_d2">
							宋代酒业兴盛，《太平广记》录天下名酒：“……
							富平之石冻春，剑南之烧春……”。此时，绵竹酿酒技艺更进一步，在传承 “剑南烧春”
							的基础上，酿制出
							“鹅黄”“蜜酒”，独特的酿酒法被收于李保《续北山酒经》。明代徐炬《酒谱》记载
							“西蜀道士杨世昌造蜜酒”，蜜酒和鹅黄不仅形成了名酒系列，更为中国文学史和酒文化史留下千古美谈。北宋苏轼与绵竹道士杨士昌的趣闻、南宋陆游的剑南诗稿等文坛佳话皆蕴含其中，这一系列发展都极大地丰富了剑南春的酿造技艺和文化内涵。
						</div>
					</div>
					<div class="orpc_item3" data-aos="zoom-in">
						<div class="tm3_d1 flex1">
							<img class="tm3_d1_img1" src="@/images/lishi/tit4.png" />
							<img class="tm3_d1_img2" src="@/images/lishi/yun2.png" />
						</div>
						<p class="tm3_line">
							<span class="le_jx"></span>
							<span class="le_hx"></span>
							<span class="le_jx"></span>
						</p>
						<div class="tm3_d2">
							元代，《酒小史》记载的名酒中仍有 “……
							剑南烧春……”，可见其盛名依旧。明代，《弘简录》记载
							“其山南枇杷、江南柑橘、剑南春酒岁一贡，以供宗庙”，《蜀中广记》也有
							“剑南贡烧春”
							记录，御酒美名代代相传。清代，《钦定四库全书总目提要》录：“剑南烧春之名，可以解李商隐诗”。清康熙年间，酿酒作坊兴起，剑南春酒传统酿造技艺进一步发展。《绵竹县志》记载
							“大曲酒，邑特产，味醇厚，色洁白，状若清露”。清末，绵竹酿酒作坊达上百家，商贸昌盛。在漫长的元明清时期，剑南春始终坚守传统酿造工艺，不断传承与发展，巩固着其名酒地位。
						</div>
					</div>
					<div class="orpc_item3" data-aos="zoom-in">
						<div class="tm3_d1 flex1">
							<img class="tm3_d1_img1" src="@/images/lishi/tit5.png" />
							<img class="tm3_d1_img2" src="@/images/lishi/yun1.png" />
						</div>
						<p class="tm3_line">
							<span class="le_jx"></span>
							<span class="le_hx"></span>
							<span class="le_jx"></span>
						</p>
						<div class="tm3_d2">
							步入新时代，剑南春乘势而上，屡获殊荣。在1979年、1984年、1989年由轻工业部举办的全国评酒会上，剑南春三届蝉联“全国名酒”称号。2005年，剑南春首家获得中国食品工业协会“纯粮固态酿造白酒认证标志”。2006年，剑南春被国家商务部认定为第一批“中华老字号”。公司主导产品“水晶剑南春”是中国老牌八大名酒之一，也是质检总局认定的“原产地保护产品”。剑南春集团的皇家剑南春、东方红、珍藏级剑南春、剑南春·老酒、水晶剑南春等30多个品牌，上百个产品，多次获得国家级、部级、省级质量奖。
						</div>
					</div>
				</div>
				<div class="rd_box">
					<record></record>
				</div>
			</div>
		</div>
		<div class="origin_phone" v-if="isPhone">
			<Header2 :searchShow="false" pageTitle="历史文化"></Header2>
			<div class="zr_tab_box flex2">
				<div @click="zrTabChange(index)" v-for="(item, index) in tabList" :key="index" class="zr_tab_item"
					:class="pcrut == index ? 'ph_act1' : ''">
					{{ item }}
				</div>
			</div>
			<div class="lsyy" v-if="pcrut==0">
				<div class="hd_img">
					<img src="@/images/lishi/bmg66.png">
				</div>
				<div class="lsyy_box">
					<div class="lsyy_item">
						<p class="lsyy_item_tit" data-aos="fade-up">战国时期</p>
						<div class="lsyy_item_text" data-aos="fade-up">
							<p>巴山钟灵，蜀水毓秀。</p>
							<p>
								在巴蜀大地上，有一条成Ｕ形的名酒带，勤劳智慧的巴蜀先民在这里创造了辉煌灿烂的巴蜀文化。座落在这条名酒带的绵竹，酿酒历史已有四千余年，广汉三星堆蜀文化遗址出土的陶酒具和绵竹金土村出土的战国时期的铜罍，提梁壶等精美酒器以及东汉时期的酿酒画像砖等文物考证以及《华阳国志·蜀志》、《晋书》等史书记载都可证实：绵竹产酒不晚于战国时期。
							</p>
						</div>
						<div class="lsyy_item_img">
							<img data-aos="fade-up" src="@/images/lishi/bmg9.png">
						</div>
					</div>
					<div class="lsyy_item">
						<p class="lsyy_item_tit" data-aos="fade-up">大唐御酒</p>
						<div class="lsyy_item_text" data-aos="fade-up">
							<p>剑南春传统酿造技艺在漫长的人类发展史中始终得到继承和发展。</p>
							<p>
								在唐朝，百业兴旺，绵竹成熟酿酒技艺下诞生的“剑南烧春”（唐代，绵竹属剑南道而得名）倾动朝野。唐人李肇的《唐·国史补》对天下名酒记载道:“酒则有……乌程之若下，剑南之烧春……”，另据黄葆真《事类统编》载曰：“为生春，《德宗本纪》剑南贡生春酒。”
								剑南烧春作为宫廷御酒而被载于《旧唐书·德宗本纪》。这是被载入正史的宫廷御酒，也是中国至今尚存的唐代名酒。</p>
						</div>
						<div class="lsyy_item_img">
							<img data-aos="fade-up" src="@/images/lishi/bmg10.png">
						</div>
					</div>
					<div class="lsyy_item">
						<p class="lsyy_item_tit" data-aos="fade-up">宋业为继</p>
						<div class="lsyy_item_text" data-aos="fade-up">
							<p>
								时至宋代，绵竹酿酒技艺在传承前代的基础上又有了新的发展，酿制出“鹅黄”、“蜜酒”，其中“蜜酒”作为名酒被列入宋伯仁所著的《酒小史》中，其独特的酿酒法被收于李保的《续北山酒经》。明代徐炬《酒谱》中记载：“西蜀道士杨世昌造蜜酒。”蜜酒鹅黄的出现，不仅形成了一个名酒系列，而且为中国文学史，也为中国酒文化史留下了千古美谈。北宋大文学家苏轼与绵竹道士杨士昌的趣闻，南宋大诗人陆游的剑南诗稿等许多文坛佳话蕴于其中。
							</p><br>
							<p>
								在宋代，剑南春酒传统酿造技艺的影响和作用不仅表现在社会经济发展上，同时还为南宋抗金做出了重要贡献。据《宋会要》记载：南宋初年，为了筹集军费抗击金兵，时任川陕巡抚处置使的绵竹人张浚从绵竹兴旺发达的酿酒业和大额的酒税上得到启发，于建炎三年（1129年）实施“隔槽酒法”，鼓励民间纳钱酿酒，次年便使四川酒税由过去的缗钱140万缗猛增至690万缗。此法前后施行了七十余年。
							</p>
						</div>
					</div>
					<div class="lsyy_item">
						<p class="lsyy_item_tit" data-aos="fade-up">明清中兴</p>
						<div class="lsyy_item_text" data-aos="fade-up">
							<p>
								明末清初，由于战乱不断，人口锐减，导致了绵竹农业荒芜，经济萧条。依附于农业发达而生产的酿酒业受到了威胁，直到清康熙年间（1662—1722）才逐渐恢复，出现了朱、杨、白、赵等较大规模酿酒作坊。剑南春酒传统酿造技艺得到进一步的发展。《绵竹县志》记载：“大曲酒，邑特产，味醇厚，色洁白，状若清露。”乾隆年间太史李调元，宦游足迹遍及大半个中国，自谓“一笑市人谁知我，醉来高卧酒家楼”，并夸口尝尽天下名酒，是个十足的饮酒行家。他说自己“天下名酒皆尝尽，却爱绵竹大曲醇。
							</p><br>
							<p>
								清末，绵竹酿酒作坊已有上百家，著名大曲坊已增到18家，绵竹商贸因此更为昌盛，出现了“山程水陆货争呼，坐贾行商日夜图。济济直如绵竹茂，芳名不愧小成都”（清诗人李锡命《咏绵竹》）的繁荣景象。</p>
						</div>
					</div>
					<div class="lsyy_item">
						<p class="lsyy_item_tit" data-aos="fade-up">天下知名</p>
						<div class="lsyy_item_text" data-aos="fade-up">
							<p>历史跨入20世纪以后，剑南春酒的发展又有了一番新的风姿。</p><br>
							<p>
								1911年，绵竹大曲首获四川省劝业会头等奖；1928年再度获四川省国货展览会奖；1929年“乾元泰”、“大道生”、“瑞昌新”、“义全和”等12家大曲酒作坊的产品，又获四川省优秀酒类奖；1932年，四川省举办第一次名产品展览会，绵竹提供了多种产品送展，其中“恒丰泰”酿造的绵竹大曲酒首次被批准使用注册商标，以崭新的时代风貌引起一番轰动。当时一诗人曾为绵竹的酿酒家题词：“百里闻香绵竹酒，天下何人不识君。”
							</p><br>
							<p>
								据《绵竹县酒类调查表》记载：至1941年，全县酿酒作坊已多达200余家，产酒二百余万公斤。从1913年绵竹“义全兴”大曲坊在成都开店销售绵竹大曲，至1949年，专门经营绵竹大曲的酒庄、酒行、酒店已达50余家，绵竹大曲被称为成都“酒坛一霸”。而且还销往重庆、武汉、南京、上海等地。台湾《四川经济志》称：“四川大曲酒，首推绵竹。”
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="tylh" v-if="pcrut==1">
				<div class="tianyi">
					<div class="tybox1">
						<p class="tb1_tit">1500年中国白酒古窖池</p>
						<div class="tb1_text">
							<p>
								天益老号是剑南春酒坊遗址中的一处，入选中国考古界权威的评选活动“2004年全国十大考古新发现”，并被列入全国重点文物保护单位。剑南春酒坊遗址能获得考古界的认证，意味着中国考古学掀开了重视工业文明研究的崭新篇章，也折射出剑南春自身深厚文化的积淀。时至今日，“天益老号”仍一直为剑南春酿造着琼浆玉液。
							</p>
						</div>
						<div class="tb1_img">
							<img src="@/images/lishi/pmg1.png">
						</div>
					</div>
					<div class="tybox2">
						<p class="tb2_tit" data-aos="fade-up">规模宏大，业内罕见</p>
						<ul class="tb2_ul">
							<li data-aos="fade-up" class="tb2_li1">
								<p class="tb2_li_tit">长度</p>
								<div class="tb2_li_num">
									<p class="tb2_li_num_left">500</p>
									<div class="tb2_li_num_right">
										<p>+</p>
										<p>米</p>
									</div>
								</div>
							</li>
							<li data-aos="fade-up" class="tb2_li2">
								<p class="tb2_li_tit">宽度</p>
								<div class="tb2_li_num">
									<p class="tb2_li_num_left">240</p>
									<div class="tb2_li_num_right">
										<p>+</p>
										<p>米</p>
									</div>
								</div>
							</li>
							<li data-aos="fade-up" class="tb2_li1">
								<p class="tb2_li_tit">总面积</p>
								<div class="tb2_li_num">
									<p class="tb2_li_num_left">120,000</p>
									<div class="tb2_li_num_right">
										<p>+</p>
										<p>平方米</p>
									</div>
								</div>
							</li>
							<li data-aos="fade-up" class="tb2_li2">
								<p class="tb2_li_tit">古窖池</p>
								<div class="tb2_li_num">
									<p class="tb2_li_num_left">706</p>
									<div class="tb2_li_num_right">
										<p class="none--188ohc">+</p>
										<p>口</p>
									</div>
								</div>
							</li>
						</ul>
						<div class="tb2_state" data-aos="fade-up">
							<p>
								剑南春酒坊遗址位于绵竹城关外西的诸葛祠、茶盘街、棋盘街和滚子坡两侧，由西北向东南呈一线分布。西北起自诸葛祠，东南抵至王麻巷口，长约500余米，宽约240余米，总面积约120，000平方米。从五路口至棋盘街南端王麻巷口，长约260米、宽240米的范围内，既是清代酿酒作坊区，也是现在剑南春酒厂的第一生产区。在11口剑南春“天益老号”古酒坊周围，明清遗存至今连续使用的古窖池有695口，面积达6万平方米，规模之巨在全行业实属罕见。大规模的古窖池群为这一区域形成了独特的微生物环境——它是剑南春酒品质高贵的保证，更是干年酒文化传承的见证。
							</p>
						</div>
					</div>
					<div class="tybox3">
						<p class="tb3_tit" data-aos="fade-up">保存完整，难以比拟</p>
						<div class="tb3_state" data-aos="fade-up">
							<p>“天益老号”酿酒作坊是保存完整的并且仍在生产的传统酿酒作坊，被认定为全国重点文物保护单位，入围世界文化遗产预备名单。</p>
							<p>
								传延下来的天益老号里的酿酒作业还是纯粹的手工操作，这里的酿酒师傅们用着古老而传统的生产工具——酒甑、云盘、鸡公车、晒笆、黄桶……其中尚有清代酿酒用水井一处，明代水缸一件，清代大曲坊木质吊牌、木匾等。发掘的遗迹现象包括晾房1座、水井1口酒窖7组共26口、炉灶5座、晾堂2座、水沟2条、池子2个盛酒坑1个以及路基、柱础和墙基等。这些保存完好的传统酿造工具有些仍然运用在现代剑南春的酿造过程中，可以说，天益老号的完整性是国内众多所谓的古窖池都难以比拟的。
							</p>
						</div>
						<div class="tb3_img">
							<img data-aos="fade-up" src="@/images/lishi/ls_img1.png">
						</div>
					</div>
					<div class="tybox3">
						<p class="tb3_tit" data-aos="fade-up">历史悠久，生生不息</p>
						<div class="tb3_state" data-aos="fade-up">
							<p>
								1985年6月6日，天益老号出土了一块砖，考古学家称之为“南齐纪年砖”，距今已有超过1500年的历史。它对于绵竹酒坊建造历史的考证有着重要的借鉴作用，而天益老号因为岁月的沉淀，愈加显得厚重。</p>
							<p>
								窖龄越长，其香越幽，其味越正，其品越高。时至今日，天益老号仍然生生不息地酿造，为剑南春出产着传世美酒，延续着千百年前的美酒传奇。剑南春酒利用1500多年来一直沿用至今的“天益老号”古老窖池群酿造，对剑南春基础酒的品质起着关键的保证作用。
							</p>
						</div>
						<div class="tb3_img">
							<img data-aos="fade-up" src="@/images/lishi/pmg3.png">
						</div>
					</div>
				</div>
			</div>
			<div class="bwg" v-if="pcrut==2">
				<div class="mb_wrap">
					<div class="mbox1">
						<div class="mbox1_st">
							<p>
								剑南春酒史博物馆，是由剑南春集团公司主理修建的酒类专业博物馆，馆址位于剑南春厂房建筑群落的中心轴线上，占地约4千平米，于2003年11月9日正式竣工开馆。博物馆主体分为序厅和主陈列厅两个部分，主要收藏和展示了与剑南春有关的从南齐到现代，长达1500余年以来的相关文献资料和酒史文物，共展出文物六百余件，图片、资料近百件。博物馆珍藏的遗存不仅是剑南春辉煌历史的见证，也是中国白酒行业珍贵的研究资料，为白酒文化的研究提供了宝贵的参考史料。
							</p>
						</div>
						<div class="mbox1_img">
							<img src="@/images/lishi/bwg1.png">
						</div>
					</div>
					<div class="mbox2">
						<p class="mb2_tit" data-aos="fade-up">博物馆导览</p>
						<ul class="mb2_ul">
							<li class="mb2_li" data-aos="fade-up" v-for="(item,index) in dlList" :key="index">
								<div class="mb2_li_img">
									<img :src="staticImg+item.image">
								</div>
								<div class="mb2_li_con">
									<p class="li2_tit1">{{item.name}}</p>
									<p class="li2_tit2">
										{{item.title}}
										<a @click="isOpen(index)" :class="item.sel?'oact':''">{{item.sel?'收回':'展开'}}</a>
									</p>
									<div class="li2_text" v-show="item.sel">
										<p>{{item.jieshao}}</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div class="mbox3">
						<p class="mb3_tit" data-aos="fade-up">馆藏精品</p>
						<div class="mb3_img">
							<img data-aos="fade-up" src="@/images/lishi/bwg7.png">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isPhone: this.$isMobile,
			pcrut: 0,
			tabList: ["历史渊源", "天益老号", '博物馆'],
			bwgshow1: false,
			bwgshow2: false,
			bwgshow3: false,
			bwgshow4: false,
			bwgshow5: false,
			dlAct: 0,
			dlList: [],
			staticImg: this.$staticImg,
		}
	},
	created() {
		this.bwgdl();
	},
	methods: {
		// 博物馆导览
		async bwgdl() {
			const res = await this.$api.bwgdl();
			if (res.code == 1) {
				this.dlList = res.data;
				for (let i = 0; i < this.dlList.length; i++) {
					this.dlList[i].sel = false;
				}
			}
		},
		zrTabChange(index) {
			this.pcrut = index;
			window.scrollTo({
				top: 0,
			});
		},
		isOpen(index) {
			this.dlList[index].sel = !this.dlList[index].sel;
			this.$forceUpdate();
		}
	},
}
</script>

<style lang="scss">
.org_cn {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	.oact {
		background-image: url("../../images/lishi/bwg9.png") !important;
		background-size: 0.267rem auto !important;
		padding-right: 0.31rem !important;
	}
	.origin_pc {
		margin-top: 76px;
		background-image: url("../../images/bgimg3.png");
		min-height: 700px;
		.orpc_wrap {
			padding-bottom: 80px;
			.hd_img {
				img {
					width: 100%;
				}
			}
			.orpc_con {
				max-width: 1271px;
				min-width: 950px;
				margin: 0 auto;
				position: relative;
				top: -120px;
				.orpc_item1,
				.orpc_item2,
				.orpc_item3 {
					background-image: url("../../images/lishi/bmg7.png");
					background-size: 100% 100%;
					background-repeat: no-repeat;
					margin-top: 80px;
				}
				.orpc_item1 {
					padding: 24px 40px 24px 62px;
					display: flex;
					justify-content: space-between;
					.orpc_item1_left {
						img {
							width: 361px;
						}
					}
					.orpc_item1_right {
						margin-left: 40px;
						flex: 1;
						text-align: left;
						img {
							width: 369px;
							margin-bottom: 20px;
						}
						p {
							color: #333;
							font-size: 18px;
							line-height: 2;
						}
					}
				}
				.orpc_item2 {
					padding: 24px 111px 24px 63px;
					display: flex;
					justify-content: space-between;
					.orpc_item2_left {
						text-align: left;
						flex: 1;
						img {
							width: 369px;
							margin-bottom: 20px;
						}
						p {
							color: #333;
							font-size: 18px;
							line-height: 2;
						}
					}
					.orpc_item2_right {
						margin-left: 90px;
						img {
							width: 241px;
						}
					}
				}
				.orpc_item3 {
					padding: 24px 62px;
					.tm3_d1 {
						align-items: flex-end;
						.tm3_d1_img1 {
							margin-bottom: 26px;
							display: block;
						}
						.tm3_d1_img1 {
							display: block;
						}
					}
					.tm3_line {
						display: flex;
						align-items: flex-end;
						.le_jx {
							width: 10px;
							height: 4px;
							background-color: #e5d9c8;
						}
						.le_hx {
							flex: 1;
							height: 1px;
							background-color: #e5d9c8;
						}
					}
					.tm3_d2 {
						margin-top: 45px;
						color: #333;
						font-size: 18px;
						line-height: 2;
						text-align: left;
					}
				}
				.rd_box {
					margin-top: 100px;
				}
			}
		}
	}
	@media screen and (max-width: 1580px) {
		.origin_pc {
			.orpc_wrap {
				.orpc_con {
					.orpc_item1 {
						.orpc_item1_right {
							p {
								font-size: 16px;
							}
						}
					}
					.orpc_item2 {
						.orpc_item2_left {
							p {
								color: #333;
								font-size: 16px;
								line-height: 2;
							}
						}
					}
					.orpc_item3 {
						.tm3_d2 {
							font-size: 16px;
						}
					}
				}
			}
		}
	}
	.origin_phone {
		.lsyy {
			padding-top: 2.5rem;
			background-image: url("../../images/bgimg3.png");
			.hd_img {
				img {
					width: 100%;
				}
			}
			.lsyy_box {
				padding: 0 0.45rem 3rem;
				.lsyy_item {
					background-color: #f5f2ee;
					margin-bottom: 0.24rem;
					padding: 0.77rem 0.29rem;
					border: 1px solid #e2d5c7;
					.lsyy_item_tit {
						color: #8e4d4d;
						font-size: 20px;
						margin-bottom: 0.25rem;
					}
					.lsyy_item_text {
						p {
							color: #333;
							font-size: 14px;
							line-height: 1.8;
							text-align: left;
						}
					}
					.lsyy_item_img {
						text-align: center;
						margin-top: 0.45rem;
						img {
							width: 4.85rem;
						}
					}
				}
			}
		}
		.tylh {
			padding-top: 2.2rem;
			padding-bottom: 2.2rem;
			background-image: url("../../images/bgimg3.png");
			.tianyi {
				.tybox1 {
					padding: 0.75rem 0 0;
					.tb1_tit {
						color: #c0494b;
						font-size: 15px;
						text-align: center;
						padding: 0 0.72rem;
						margin-bottom: 0.29rem;
					}
					.tb1_text {
						padding: 0 0.72rem;
						p {
							text-align: left;
							color: #333;
							font-size: 14px;
							line-height: 1.7;
						}
					}
					.tb1_img {
						img {
							width: 100%;
							display: block;
						}
					}
				}
				.tybox2 {
					padding: 1.39rem 0.75rem 0.61rem;
					background: url("../../images/lishi/pmg2.png") no-repeat 50%;
					background-size: cover;
					.tb2_tit {
						text-align: center;
						color: #fff;
						font-size: 20px;
						margin-bottom: 1.12rem;
						font-weight: 700;
					}
					.tb2_ul {
						display: flex;
						justify-content: space-between;
						flex-wrap: wrap;
						.tb2_li1,
						.tb2_li2 {
							margin-bottom: 0.8rem;
							.tb2_li_tit {
								color: #fff;
								font-size: 13px;
							}
							.tb2_li_num {
								display: flex;
								align-items: center;
								.tb2_li_num_left {
									font-size: 36px;
									color: #fff;
								}
								.tb2_li_num_right {
									color: #fff;
									font-size: 13px;
								}
							}
						}
						.tb2_li1 {
							width: 65%;
						}
						.tb2_li2 {
							width: 35%;
						}
					}
					.tb2_state {
						padding-top: 0.32rem;
						p {
							color: #fff;
							font-size: 12px;
							line-height: 1.7;
						}
					}
				}
				.tybox3 {
					padding: 0.67rem 0.4rem;
					.tb3_tit {
						text-align: center;
						color: #c0494b;
						font-size: 18px;
						font-weight: 700;
						margin-bottom: 0.32rem;
					}
					.tb3_state {
						margin-bottom: 0.35rem;
						p {
							color: #333;
							font-size: 14px;
							line-height: 1.7;
							text-align: left;
						}
					}
					.tb3_img {
						img {
							width: 100%;
						}
					}
				}
			}
		}
		.bwg {
			padding-top: 2.2rem;
			padding-bottom: 2.2rem;
			background-image: url("../../images/bgimg3.png");
			.mb_wrap {
				.mbox1 {
					.mbox1_st {
						padding: 0.93rem 0.72rem 1.01rem;
						p {
							text-align: left;
							color: #444;
							font-size: 14px;
							line-height: 1.8;
						}
					}
					.mbox1_img {
						img {
							width: 100%;
						}
					}
				}
				.mbox2 {
					padding: 0.67rem 0.53rem 0.4rem;
					background-color: #dfdfdf;
					.mb2_tit {
						text-align: center;
						color: #c0494b;
						font-size: 19px;
						margin-bottom: 0.4rem;
						font-weight: 700;
					}
					.mb2_ul {
						.mb2_li {
							margin-bottom: 0.37rem;
							box-shadow: 0 2px 2px 0 hsla(0, 0%, 60%, 0.1);
							.mb2_li_img {
								img {
									width: 100%;
									display: block;
								}
							}
							.mb2_li_con {
								background-color: #fff;
								padding: 0.29rem 0.32rem;
								.li2_tit1 {
									color: #c0494b;
									font-size: 18px;
									margin-bottom: 0.15rem;
									text-align: left;
								}
								.li2_tit2 {
									color: #333;
									font-size: 15px;
									padding-right: 1.44rem;
									position: relative;
									text-align: left;
									a {
										position: absolute;
										right: 0;
										top: 0;
										padding-right: 0.29rem;
										color: #999;
										font-size: 15px;
										background-image: url("../../images/lishi/bwg8.png");
										background-position: 100%;
										background-size: 0.13rem auto;
										background-repeat: no-repeat;
									}
								}
								.li2_text {
									color: #666;
									font-size: 14px;
									line-height: 1.7;
									padding-top: 0.24rem;
									p {
										text-align: left;
									}
								}
							}
						}
					}
				}
				.mbox3 {
					padding: 0.77rem 0.27rem 0.4rem;
					.mb3_tit {
						text-align: center;
						color: #c0494b;
						font-size: 19px;
						margin-bottom: 0.4rem;
						font-weight: 700;
					}
					.mb3_img {
						img {
							width: 100%;
						}
					}
				}
			}
		}
	}
}
</style>